import { JobsComponent } from '@umd-dit/jobs-component-react';
import '@umd-dit/jobs-component-react/style.css';
import { useAuth } from "@/context/AuthContext.tsx";

export default function Jobs() {
  const { selectedOrganizationId, selectedWorkspaceId, isAdmin } = useAuth();

  return (
    <div className="container mx-auto px-4 py-4">
      <JobsComponent
        app_id="legislative-review"
        org_id={selectedOrganizationId || 'demo-org'}
        ws_id={selectedWorkspaceId || 'demo-workspace'}
        isAdmin={isAdmin}
        metadata_fields={{ "bill_number": "Bill Number" }}
      />
    </div>
  );
}